import styled from 'styled-components';

export const Eyebrow = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 54px;
  text-transform: uppercase;
  color: #4a5775;
  text-align: center;
  margin: 0;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 14px;
    line-height: 54px;
  }
`;

export const Title = styled.h4`
  font-size: 40px;
  font-weight: 700;
  line-height: 60px;
  color: ${({ theme }) => theme.colors.topicBlue};
  margin: 0 auto 16px;
  max-width: 1120px;
  text-align: center;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 24px;
    font-weight: 400;
    line-height: 35px;
    margin-bottom: 25px;
  }
`;

export const StepsSubtitle = styled.p`
  font-size: 20px;
  font-weight: 300;
  line-height: 35px;
  color: ${({ theme }) => theme.colors.topicBlue};
  margin: 0 auto;
  max-width: 1079px;
  text-align: center;
  white-space: nowrap;

  ${({ theme }) => theme.breakpoints.down('lg')} {
    white-space: normal;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 16px;
    line-height: 26px;
  }
`;

export const SectionDivider = styled.div<{
  $marginTop?: boolean;
  $marginBottom?: boolean;
}>`
  width: 1400px;
  max-width: calc(100% - 40px);
  height: 1px;
  margin: ${({ $marginTop = true }) => ($marginTop ? '80px' : '0')} auto
    ${({ $marginBottom }) => ($marginBottom ? '80px' : '0')};
  border-top: 1px dashed ${({ theme }) => theme.colors.topicBlue};
  opacity: 0.4;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    max-width: 100%;
    margin-top: ${({ $marginTop = true }) => ($marginTop ? '64px' : '0')};
    margin-bottom: ${({ $marginBottom }) => ($marginBottom ? '64px' : '0')};
  }
`;
